<template>
  <div class="footer_area_wrap">
    <div class="footer_area">
      <div class="left_area">
        <div class="title">联系我们</div>
        <div class="text">
          <img src="../assets/imgs/message.png" alt="" />&nbsp;&nbsp;&nbsp;
          <span>info@smart-path.net</span>
        </div>
        <div class="text">
          <img src="../assets/imgs/phone.png" alt="" />&nbsp;&nbsp;&nbsp;
          <span>+86-21-6427 6820</span>
        </div>
        <div class="text">
          <img src="../assets/imgs/site.png" alt="" />&nbsp;&nbsp;&nbsp;
          <span>上海市漕溪北路18号上海实业大厦18楼A-E座</span>
        </div>
      </div>
      <div class="center_area">
        <div class="router" v-for="(item, index) of tabs" :key="index">
          <div class="title">
            <span @click="checkTab(item)">{{ item.lable }}</span>
          </div>
          <div class="text" v-for="(child, ind) of item.children" :key="ind">
            <span @click="checkTab(child)">{{ child.lable }}</span>
          </div>
        </div>
      </div>
      <div class="right_area">
        <div class="title">思勃公众号</div>
        <img src="../assets/imgs/official_account.png" alt="" />
      </div>
    </div>
  </div>
  <div class="record_wrap">
    <div class="record">
      <span>Copyright 2008-2021 © 上海思勃商务咨询有限公司</span
      >&nbsp;&nbsp;&nbsp;
      <a href="https://beian.miit.gov.cn/">沪ICP备14045652号</a
      >&nbsp;&nbsp;&nbsp;&nbsp;
      <a
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402002751"
        >沪公网安备 31010402002751号</a
      >&nbsp;<img src="../assets/imgs/police_logo.png" alt="" />
    </div>
  </div>
</template>

<script lang="ts">
import { ref } from "@vue/reactivity";
import { useRouter } from "vue-router";
export default {
  setup() {
    const tabs: any = ref<any>([
      {
        lable: "首页",
        router: "/",
        children: [
          {
            lable: "监测渠道",
            router: "/",
            scrollTop: 620,
          },
          {
            lable: "数据维度",
            router: "/",
            scrollTop: 1244,
          },
          {
            lable: "报告时间",
            router: "/",
            scrollTop: 1868,
          },
          {
            lable: "市场追踪",
            router: "/",
            scrollTop: 2458,
          },
          {
            lable: "网购市场概览",
            router: "/",
            scrollTop: 3306,
          },
        ],
      },
      // {
      //   lable: "免费报告",
      //   router: "/report",
      //   children: [
      //     {
      //       lable: "数据报告",
      //       router: "/report",
      //       scrollTop: 289,
      //     },
      //   ],
      // },
      {
        lable: "联系我们",
        router: "/connect",
        children: [
          {
            lable: "填写信息",
            router: "/connect",
            scrollTop: 289,
          },
        ],
      },
      {
        lable: "加入我们",
        router: "/join",
        children: [
          {
            lable: "岗位招聘",
            router: "/join",
            scrollTop: 289,
          },
        ],
      },
      {
        lable: "关于我们",
        router: "/about",
        children: [
          {
            lable: "思勃简介",
            router: "/about",
            scrollTop: 289,
          },
          {
            lable: "联系我们",
            router: "/about",
            scrollTop: 930,
          },
        ],
      },
    ]);
    const router = useRouter();
    const checkTab = (checkedTab: any) => {
      router.push(checkedTab.router);
      setTimeout(() => {
        if (document.documentElement) {
          document.documentElement.scrollTop = checkedTab.scrollTop || 0;
        } else {
          document.body.scrollTop = checkedTab.scrollTop || 0;
        }
      }, 100);
    };
    return {
      tabs,
      checkTab,
    };
  },
};
</script>
<style scoped lang="less">
.footer_area_wrap {
  height: 260px;
  padding-top: 72px;
  background: #f7f7fb;
  min-width: 1200px;
  position: relative;
  overflow: hidden;
  .footer_area {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .title {
      color: #2c2d3f;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 24px;
    }
    .text {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #596675;
      line-height: 24px;
      margin-top: 10px;
      img {
        width: 16px;
      }
    }
    .left_area {
      width: 250px;
    }
    .center_area {
      display: flex;
      justify-content: space-between;
      .router {
        width: 130px;
        .title,
        .text {
          span {
            cursor: pointer;
          }
        }
      }
    }
    .right_area {
      img {
        width: 118px;
      }
    }
  }
  &::before {
    content: "";
    position: absolute;
    background: url(../assets/imgs/official_icon.png) no-repeat;
    background-size: 100%;
    width: 350px;
    height: 171px;
    left: -80px;
    bottom: 0px;
    filter: grayscale(100%);
    opacity: 0.1;
    transform: rotateY(180deg);
  }
}
.record_wrap {
  line-height: 68px;
  background: #ededf4;
  min-width: 1200px;
  .record {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    color: #2c2d3f;
    font-size: 14px;
  }
}
</style>
